import { useEffect } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Gallery from './components/Gallery';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingQR from '../../components/feature/FloatingQR';
import { useSEO, generateLocalBusinessSchema, generateWebPageSchema, generateServiceSchema } from '../../utils/seo';

export default function HomePage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://abrilweldworkspro.com';
  
  // Combined schema for home page
  const combinedSchema = {
    '@context': 'https://schema.org',
    '@graph': [
      generateLocalBusinessSchema(),
      generateWebPageSchema(
        'Industrial Welding & Metal Fabrication in Atlanta GA | April Weld Works',
        'Industrial welding and metal fabrication services in Atlanta, GA and Metro Atlanta. Structural steel, MIG/TIG welding, repairs and ornamental metal. Free quotes.'
      ),
      generateServiceSchema()
    ]
  };

  useSEO({
    title: 'Industrial Welding & Metal Fabrication in Atlanta GA | April Weld Works',
    description: 'Industrial welding and metal fabrication services in Atlanta, GA and Metro Atlanta. Structural steel, MIG/TIG welding, repairs and ornamental metal. Free quotes.',
    keywords: 'industrial welding Atlanta GA, metal fabrication Atlanta, welding services Georgia, ornamental metal Atlanta, soldadura industrial Atlanta, fabricacion de metal Georgia',
    canonical: siteUrl,
    ogType: 'website',
    ogTitle: 'Industrial Welding & Metal Fabrication in Atlanta GA | April Weld Works',
    ogDescription: 'Industrial welding and metal fabrication services in Atlanta, GA and Metro Atlanta. Structural steel, MIG/TIG welding, repairs and ornamental metal. Free quotes.',
    schema: combinedSchema
  });

  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <Services />
      <Gallery />
      <Contact />
      <Footer />
      <FloatingQR />
    </div>
  );
}
